module.exports = __webpack_public_path__ + "static/sui-table-compact-8448794948eadd3ae6d0799651bb9a87.png";